import { Suspense, lazy } from 'react';
import { Row, Col } from 'src/componentes/grid';
import PanelCollapse from 'src/componentes/panel-collapse';
import Input from 'src/componentes/input';
import Panel from 'src/componentes/panel';
import LoadingScreen from 'src/componentes/LoadingScreen';
import StatusBadge from 'src/componentes/StatusBadge';
import TipoDocumentoLookup from 'src/lookups/TipoDocumentoLookup';
import ColaboradorLookup from 'src/lookups/colaborador';
import OrganizacaoLookup from 'src/lookups/item-organizacao';
import DocumentoLookup from 'src/lookups/DocumentoLookup';
import { capitalizeFirstLetter } from 'src/utils/string';
import {
  ENTIDADES_CUSTOMIZADAS,
  STATUS_GERAL_DOCUMENTO,
} from 'src/utils/constants';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';
import DocumentoSituacaoAtualCard from './components/DocumentoSituacaoAtualCard';
import StatusGeralDocumentoLookup from 'src/lookups/StatusGeralDocumentoLookup';

const Historico = lazy(() => import('src/paginas/versao-alteracao'));
const ALTURA_CAMPO_PADRAO = '38px';
const STATUS_GERAL_DOCUMENTO_LOOKUP_DATA = {
  idsIgnorar: [
    STATUS_GERAL_DOCUMENTO.RASCUNHO,
    STATUS_GERAL_DOCUMENTO.REPROVADO,
    STATUS_GERAL_DOCUMENTO.REPROVADO_AGUARDANDO_NOVA_SUBMISSAO,
  ],
};

function ResumoTab({
  intl,
  resources,
  locale,
  item,
  model,
  isNew,
  isCurrentDocument,
  isDisabled,
  isDocumentTypeDisabled,
  isStatusGeralDisabled,
  documentName,
  documentType,
  hasErrorField,
  onChangeValue,
}) {
  const exibirCodigoImportacao = !model?.utilizarCodigoAutomatico || !isNew;
  const hasDocumentoAnexo =
    Array.isArray(model?.arquivos) && model.arquivos.length > 0;

  const renderStatus = () => {
    const status = model?.status;

    if (!status?.cor && !status?.corFundo) return null;

    return (
      <div style={{ marginBottom: '1rem' }}>
        <label>{intl.formatMessage({ id: 'status' })}</label>
        <div>
          <StatusBadge
            text={status?.nome}
            textColor={status?.corFundo ? status?.cor : undefined}
            backgroundColor={status?.corFundo || status?.cor}
          />
        </div>
      </div>
    );
  };

  return (
    <div style={{ paddingBottom: 24 }}>
      <PanelCollapse
        open={true}
        header={intl.formatMessage({ id: 'label.informacoesBasicas' })}
      >
        {isCurrentDocument && item && hasDocumentoAnexo && model?.id && (
          <>
            <Row>
              <Col md={12}>
                <DocumentoSituacaoAtualCard
                  locale={locale}
                  model={model}
                  documentName={documentName ?? model.nome}
                  documentType={documentType ?? model.tipoDocumento?.nome}
                />
              </Col>
            </Row>
            <hr />
          </>
        )}
        {isCurrentDocument && item && !hasDocumentoAnexo && (
          <Row>
            <Col md={12}>{renderStatus()}</Col>
          </Row>
        )}
        <Row>
          {exibirCodigoImportacao && (
            <Col md={6}>
              <Input
                disabled={
                  isDisabled ||
                  (model?.utilizarCodigoAutomatico && isNew) ||
                  (model?.utilizarCodigoAutomatico &&
                    !model?.permiteAlterarCodigoAutomatico)
                }
                style={{ height: ALTURA_CAMPO_PADRAO }}
                model={{
                  label: intl.formatMessage({ id: 'idIntegracao' }),
                  value: model?.idIntegracao,
                  requestChange: (value) =>
                    onChangeValue('idIntegracao', value),
                  errors: hasErrorField('idIntegracao'),
                }}
                required
              />
            </Col>
          )}
          <Col md={exibirCodigoImportacao ? 6 : 12}>
            <Input
              disabled={isDisabled}
              style={{ height: ALTURA_CAMPO_PADRAO }}
              model={{
                label: intl.formatMessage({ id: 'nome' }),
                value: model?.nome,
                requestChange: (value) => onChangeValue('nome', value),
                errors: hasErrorField('nome'),
              }}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <StatusGeralDocumentoLookup
              model={{
                label: intl.formatMessage({ id: 'status' }),
                value: model?.statusGeral,
                requestChange: (value) => onChangeValue('statusGeral', value),
                errors: hasErrorField('statusGeral'),
              }}
              data={STATUS_GERAL_DOCUMENTO_LOOKUP_DATA}
              disabled={isStatusGeralDisabled}
              controlStyle={{ height: ALTURA_CAMPO_PADRAO }}
              required
            />
          </Col>
          <Col md={6}>
            <OrganizacaoLookup
              disabled={isDisabled}
              clearable
              controlStyle={{ height: ALTURA_CAMPO_PADRAO }}
              labelValue={capitalizeFirstLetter(resources.area)}
              model={{
                label: capitalizeFirstLetter(resources.area),
                value: model?.area,
                requestChange: (value) => onChangeValue('area', value),
                errors: hasErrorField('area'),
              }}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ColaboradorLookup
              required
              disabled={isDisabled}
              clearable
              multi
              controlStyle={{ height: ALTURA_CAMPO_PADRAO }}
              model={{
                label: capitalizeFirstLetter(resources.responsaveis),
                value: model?.responsaveis,
                requestChange: (value) => onChangeValue('responsaveis', value),
                errors: hasErrorField('responsaveis'),
              }}
            />
          </Col>
        </Row>
        <Row>
          {isCurrentDocument && (
            <Col md={6}>
              <TipoDocumentoLookup
                disabled={isDisabled || isDocumentTypeDisabled}
                controlStyle={{ height: ALTURA_CAMPO_PADRAO }}
                model={{
                  label: intl.formatMessage({
                    id: 'labelTipoDocumento',
                  }),
                  value: model?.tipoDocumento,
                  requestChange: (value) =>
                    onChangeValue('tipoDocumento', value),
                  errors: hasErrorField('tipoDocumento'),
                }}
                required
              />
            </Col>
          )}
          <Col md={isCurrentDocument ? 6 : 12}>
            <DocumentoLookup
              disabled={isDisabled}
              clearable
              controlStyle={{ height: ALTURA_CAMPO_PADRAO }}
              data={{ apenasPastas: true, documentoAtualId: model?.id }}
              parameters={{
                apenasPastas: true,
                documentoAtualId: model?.id,
              }}
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'pastaDocumentos' })
                ),
                value: model?.documentoPai,
                requestChange: (value) => onChangeValue('documentoPai', value),
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Input
              type="textarea"
              rows={4}
              disabled={isDisabled}
              style={{ height: '130px' }}
              model={{
                label: intl.formatMessage({ id: 'descricao' }),
                value: model?.descricao,
                requestChange: (value) => onChangeValue('descricao', value),
                errors: hasErrorField('descricao'),
              }}
            />
          </Col>
        </Row>
      </PanelCollapse>

      {isCurrentDocument && (
        <PanelCollapse
          open={false}
          header={intl.formatMessage({ id: 'informacoesComplementares' })}
        >
          <DesenharCampoCustomizado
            disabled={isDisabled}
            mdFields={4}
            mdFieldsTo={[2]}
            model={{
              value: model?.camposCustomizados,
              requestChange: (value) =>
                onChangeValue('camposCustomizados', value),
            }}
            tipoItem={ENTIDADES_CUSTOMIZADAS.GESTAO_DOCUMENTOS}
          />
        </PanelCollapse>
      )}

      <PanelCollapse
        open={false}
        loadChildrenOnOpen={true}
        header={intl.formatMessage({ id: 'label.historico' })}
      >
        <Suspense fallback={<LoadingScreen />}>
          {model?.id ? (
            <Panel style={{ marginBottom: 0 }}>
              <Historico url={`/Documento/ObterHistorico`} id={model?.id} />
            </Panel>
          ) : (
            <span>-</span>
          )}
        </Suspense>
      </PanelCollapse>
    </div>
  );
}

export default ResumoTab;
